export * from './ResourceTable2';
